<template>
  <el-container direction="vertical">
    <ClientHeader />
    <el-container>
      <ClientSidebar />
      <el-main>
        <transition name="fade" mode="out-in">
          <ClientProfile />
        </transition>
        <div class="invitation-shadow"></div>
        <InvitePassword
          v-bind:flagVisible="flagVisible.modalPassword" v-on:handleComplete="handleComplete"
          v-bind:actionItem="user"
        />
        <InviteComplete
          v-bind:flagVisible="flagVisible.modalComplete"
        />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { reactive } from 'vue'
import ClientHeader from '@/components/layouts/client/Header'
import ClientSidebar from '@/components/layouts/client/Sidebar'
import ClientProfile from '@/views/client/Profile'
import InvitePassword from '@/views/users/modals/InvitePassword'
import InviteComplete from '@/views/users/modals/InviteComplete'
export default {
  name: 'ClientLayout',
  components: {
    ClientHeader,
    ClientSidebar,
    ClientProfile,
    InvitePassword,
    InviteComplete
  },
  data () {
    const flagVisible = reactive({
      modalPassword: true,
      modalComplete: false
    })
    return {
      invitationId: this.$route.params.uuid,
      flagVisible,
      user: {}
    }
  },
  created () {
    this.getInvitation()
  },
  methods: {
    getInvitation () {
      const url = `/api/v1/atk_player/invitations/${this.invitationId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.user = res.data.user_info
          that.$store.dispatch('invitation', res.data.token)
        }
      }).catch(function (err) {
        console.error('getInvitation', err)
      })
    },
    handleComplete () {
      this.flagVisible.modalPassword = false
      this.flagVisible.modalComplete = true
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  overflow-y: hidden;
}
.invitation-shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(219, 231, 234, 0.85);
}
</style>
